import { gql } from '@apollo/client';

export const UPSERT_CARD = gql`
  mutation UpsertCard(
    $create: CardCreationInput!
    $update: CardUpdateInput!
    $where: CardUniqueFilterInput!
  ) {
    upsertCard(create: $create, update: $update, where: $where) {
      id
      title
      secondaryTitle
      description
      url
      label
      brandKey
      status
      media
      body
      categories(first: 100) {
        order
        category {
          id
          level
          title
        }
      }
      tags(first: 100) {
        order
        tag {
          id
          title
          type
        }
      }
    }
  }
`;
